interface User {
  id: number;
  username: string;
  email: string;
  role?: string;
  first_name?: string;
  last_name?: string;
}

interface Vehicle {
  id: number;
  user_id?: number;
  [key: string]: any;
}

interface EventLike {
  id: number;
  organizer_id?: number;
  [key: string]: any;
}

/**
 * Check if the current user can edit a specific vehicle
 * Super admins can edit any vehicle, regular users only their own
 */
export const canEditVehicle = (user: User | null, vehicle: Vehicle | null): boolean => {
  if (!user || !vehicle || vehicle.user_id === undefined) {
    return false;
  }

  // Super admins can edit any vehicle
  if (user.role === 'super_admin') {
    return true;
  }

  // Regular users can only edit their own vehicles
  return user.id === vehicle.user_id;
};

/**
 * Check if the current user can manage a specific event
 * Super admins can manage any event; organizers only their own
 */
export const canManageEvent = (user: User | null, event: EventLike | null): boolean => {
  if (!user || !event || event.organizer_id === undefined) {
    return false;
  }
  if (user.role === 'super_admin') {
    return true;
  }
  return user.id === event.organizer_id;
};

/**
 * Check if the current user is a super admin
 */
export const isSuperAdmin = (user: User | null): boolean => {
  return user?.role === 'super_admin' || false;
};

/**
 * Check if the current user is the owner of a vehicle
 */
export const isVehicleOwner = (user: User | null, vehicle: Vehicle | null): boolean => {
  if (!user || !vehicle || vehicle.user_id === undefined) {
    return false;
  }
  return user.id === vehicle.user_id;
};

/**
 * True when a super admin is editing content they do not own.
 */
export const isAdminEditingOthersVehicle = (
  user: User | null,
  vehicle: Vehicle | null
): boolean => {
  return !!(user && isSuperAdmin(user) && vehicle && !isVehicleOwner(user, vehicle));
};

export const isAdminEditingOthersEvent = (
  user: User | null,
  event: EventLike | null
): boolean => {
  if (!user || !event || event.organizer_id === undefined) {
    return false;
  }
  return isSuperAdmin(user) && user.id !== event.organizer_id;
};
 